export class Video {
  constructor(
    public name: string,
    public id?: number,
    public host_identifier?: string,
    public host_params?: string, // for example 'h=498y9882827356' a security hash unique to each video, generated by Vimeo and required by Vimeo for some purposes. h MUST BE THE FIRST param!!!!!
    public duration?: number,
    public host?: string, // 'vimeo'
  ){}
}